import React, { useEffect, useState } from "react";
import "./App.scss";

import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Home from "./page/Home/Home";
import Products from "./page/Products/Products";
import Product from "./page/Product/Product";
import Contact from "./page/Contact/Contact";
import About from "./page/About/About";
import Conditions from "./page/t&c/Conditions";
import PrivacyPolicy from "./page/Policy/PrivacyPolicy";
import Succsess from "./components/payment/Succsess";
import Failed from "./components/payment/Failed";
import Navbar from "./components/Navbar/Navbar";
import Whatapp from "./components/whatapp/Whatapp";
import Footer from "./components/Footer/Footer";
import Error from "./page/Error/Error";
import Promotion from "./page/promotion/Promotion";
import Modal from "./components/modal/Modal";
import SubBrands from "./page/snackSubBrand/SubBrands";
import Snacks from "./page/snacks/Snacks";
import AlKabeerContest from "./page/alKabeerContest/AlKabeerContest";
import ScrollTop from "./components/scrollTop/ScrollTop";
import axios from "axios";
import Winner from "./page/winner/Winner";
import { WinnerProvider } from "./util/WinnerContext";
import PickWinner from './admin/pickWinner/PickWinner'
import Participants from "./page/alKabeerContest/Participants";
import Winners from "./page/alKabeerContest/Winners";




// pages for the router

axios.defaults.baseURL = "https://al-kabeer-contest.notionsgroup.com/api/v1";
 //axios.defaults.baseURL = "http://localhost:9876/api/v1";
axios.defaults.withCredentials = true;

const Layout = () => {


  return (
    <div  className="app" style={{}} >
      <ScrollTop/>
      <Navbar />
      {/* <Whatapp /> */}

      <Outlet  />
      <Footer />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/products/:id",
        element: <Products />,
      },

      {
        path: "/product/:id",
        element: <Product />,
      },
      {
        path: "/categories",
        element: <Snacks />,
      },

      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/pick-winner",
        element: <PickWinner />,
      },
      {
        path: "/al-kabeer-contest",
        element: <AlKabeerContest />,
      },
      {
        path: "/Participants",
        element: <Participants />,
      },
      {
        path: "/winners",
        element: <Winners />,
      },
      {
        path: "/promotion",
        element: <Promotion />,
      },
      {
        path: "/Xl",
        element: <SubBrands />,
      },
      {
        path: "/winner",
        element: <Winner />,
      },

      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/terms-&-conditions",
        element: <Conditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/succsess",
        element: <Succsess />,
      },
      {
        path: "/failed",
        element: <Failed />,
      },
      {
        path: "*",
        element: <Error />,
      },
      {
        path: "/mail",
        element: <Error />,
      },
    ],
  },
]);

//main component

const App = () => {
   const [isModalOpen, setIsModalOpen] = useState(false);

  //  useEffect(() => {
  //    setTimeout(() => {
  //      setIsModalOpen(true);
  //    }, 2000);
  //  }, []);

   const openModal = () => {
     setIsModalOpen(true);
   };

   const closeModal = () => {
     setIsModalOpen(false);
   };
  return (
    <div>
      <WinnerProvider>
        <RouterProvider router={router} />{" "}
      </WinnerProvider>

      {/* <Modal isOpen={isModalOpen} closeModal={closeModal}></Modal> */}
    </div>
  );
};

export default App;
